import { httpsCallable } from "firebase/functions";
import { sendSignInLinkToEmail } from "firebase/auth";
import { auth, functions } from "../firebase";
const call = (name, data) =>
  httpsCallable(functions, name)(data).then((response) => response.data);
export const listClinicTeam = (clinicId) =>
  call("listClinicTeam", { clinicId });
export const saveClinicMember = (clinicId, uid, profile, revision) =>
  call("saveClinicMember", { clinicId, uid, profile, revision });
export const setClinicMemberState = (clinicId, uid, activo, revision) =>
  call("setClinicMemberState", { clinicId, uid, activo, revision });
export const cancelClinicInvitation = (clinicId, invitationId) =>
  call("cancelClinicInvitation", { clinicId, invitationId });
export async function inviteClinicMember(clinicId, profile) {
  const invitation = await call("createClinicInvitation", {
    clinicId,
    profile,
  });
  try {
    await sendSignInLinkToEmail(auth, profile.email.trim().toLowerCase(), {
      url: invitation.continueUrl,
      handleCodeInApp: true,
    });
  } catch (error) {
    await call("markClinicInvitationFailed", {
      clinicId,
      invitationId: invitation.id,
      deliveryToken: invitation.deliveryToken,
    }).catch(() => {});
    throw new Error(
      error.code === "auth/operation-not-allowed"
        ? "El acceso por enlace de correo aún no está habilitado en Firebase. La invitación sigue pendiente y puedes reenviarla."
        : error.code === "auth/unauthorized-continue-uri"
          ? "El dominio de activación aún no está autorizado. La invitación no se ha enviado."
          : "No se pudo enviar el correo de invitación. Revisa la conexión y vuelve a intentarlo.",
    );
  }
  await call("markClinicInvitationSent", {
    clinicId,
    invitationId: invitation.id,
    deliveryToken: invitation.deliveryToken,
  }).catch(() => {});
  return invitation;
}
